import React from 'react';
import style from './metricCard.module.css';
import { Icons } from '../utils/Icons';
import { useNavigate } from 'react-router-dom';

function MetricCard({ title, value, growth, growthText }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (title === "Total Products") {
      navigate("/product-dashboard/analytics");
    } else if (title === "Total Orders") {
      navigate("/product-dashboard/orderstatusanalytics");
    } else if (title === "Total Sales") {
      navigate("/product-dashboard/salesanalytics");
    }
  };

  const getIcon = () => {
    switch(title) {
      case "Total Products":
        return <Icons.FaBox size={20} />;
      case "Total Orders":
        return <Icons.FaShoppingCart size={20} />;
      case "Total Sales":
        return <Icons.FaDollarSign size={20} />;
      default:
        return <Icons.FaUsers size={20} />;
    }
  };

  return (
    <div 
      className={style.cardContainer} 
      onClick={handleClick} 
      style={{ 
        cursor: (title === "Total Products" || title === "Total Orders" || title === "Total Sales") 
          ? 'pointer' 
          : 'default' 
      }}
    >
      <div className={style.cardTitle}>{title}</div>
      <div className={style.cardContent}>
        <div className={style.cardValue}>{value}</div>
        <div className={style.cardIcon}>
          {getIcon()}
        </div>
      </div>
      <div className={style.cardGrowth}>
        <span className={style.tagline}>
          <div className={style.icon}>
            <Icons.FaArrowTrendUp />
            {growth}
          </div>
          {growthText}
        </span>
      </div>
    </div>
  );
}

export default MetricCard;